// 公共Reducer
import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import { user } from './modules/user';
import { organization } from './modules/organization';
import { staffList } from './modules/staff_list';
import { allUser } from './modules/all_user';
import { contractType } from './modules/contract_type';
import { industryList } from './modules/industry_list';
import { accountInfo } from './modules/account_info';
import { incomeInfo } from './modules/income_info';
import { fundsBook } from './modules/funds_book';
import { financeStatis } from './modules/finance_statis';
import { operationalStatis } from './modules/operational_statis';
import { recoupInfo } from './modules/recoup_info';
import { companyList } from './modules/company_list';
import { departmentList } from './modules/department_list';
import { enableOrgTree } from './modules/enable_org_tree';
import { workOrgList } from './modules/work_org_list';
import { coreAccountSearch } from './modules/core_account_search';
import { hrSearch } from './modules/hr_search';
import { backInfo } from './modules/back_info';
import { backInfoStandby } from './modules/back_info_standby';
import incubatorReducers from './modules/incubator/reducers';
import financeReducers from './modules/finance/reducers';
import { menu } from './modules/menu';

const rootReducer = combineReducers({
  routing,
  user,
  organization,
  menu,
  all_user: allUser,
  back_info: backInfo,
  back_info_standby: backInfoStandby,
  contract_type: contractType,
  industry_list: industryList,
  account_info: accountInfo,
  income_info: incomeInfo,
  funds_book: fundsBook,
  finance_statis: financeStatis,
  operational_statis: operationalStatis,
  recoup_info: recoupInfo,
  company_list: companyList,
  staff_list: staffList,
  department_list: departmentList,
  enable_org_tree: enableOrgTree,
  work_org_list: workOrgList,
  core_account_search: coreAccountSearch,
  hr_search: hrSearch,
  ...incubatorReducers,
  ...financeReducers,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js